import React, { FC, useEffect, useState } from 'react';
import { Icons } from '@components/Icon';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentWrapper from '../../ui/Content/Content';
import { useSearchParams } from 'next/navigation'
import {
    Section,
    SectionDescription,
    SectionHeader,
    Sections,
    Wrapper,
    TransportationDescription,
    TransportationHeader,
    TransportationHeaderIcon,
    TransportationHeaderTexts,
    TransportationHeaderTitle,
    TransportationHeaderBanner,
    TransportationHeaderDesc,
    TransportationHeaderRights,
    TransportationOption,
    Link
} from './AcademyMethods.elements';


const METHODS = [
    { id: 1, question: 'Profivzdelavanie.sk', description: 'Možnosť začať študovať okamžite s cieľom získať <strong>oficiálne osvedčenie</strong>.' },
    { id: 2, question: 'Vzdelavamsa.sk (Ministerstvo školstva SR)', description: 'Pre zamestnaných aj nezamestnaných, ktorí chcú získať štátnu <strong>dotáciu a oficiálne osvedčenie</strong>.' },
    { id: 3, question: 'Ústredie práce, sociálnych vecí a rodiny SR', description: 'Pre záujemcov o zamestnanie evidovaných na úrade práce, ktorí si chcú zvýšiť šance na profesijné uplatnenie, <strong>získať oficiálne osvedčenie a príspevok na vzdelávanie v rámci projektu „Zručnosti pre trh práce“</strong>.' }
];

interface AcademyMethodsProps { }

const AcademyMethodsTemplate: FC<AcademyMethodsProps> = () => {
    const { t } = useTranslation();

    const [openedAreas, setOpenedAreas] = useState([]);

    const searchParams = useSearchParams()

    useEffect(() => {
        const method = searchParams.get('program')
        if (method == 'profivzdelavanie') {
            toggleTransportationOption(1);
        } else if (method == 'vzdelavamsa') {
            toggleTransportationOption(2);
        } else if (method == 'upsvr') {
            toggleTransportationOption(3);
        }
    }, []);

    const toggleTransportationOption = (id: number) => {
        if (openedAreas.includes(id)) {
            setOpenedAreas([]);
        } else {
            setOpenedAreas([]);
            setTimeout(() => {
                window.scrollTo({
                    top: document.getElementById(`${id}`).offsetTop - 120,
                    behavior: 'smooth',
                });
                setOpenedAreas([id]);
            }, 50);
        }
    };

    return (
        <ContentWrapper mobileSidePadding={20} id="moznostAbsolvovania">
            <TitleTemplate tagType={TitleTagTypes.H2} isBlack>
                {t('academy.methods.title')}
            </TitleTemplate>
            <Wrapper>
                <Sections>
                    <Section>
                        <SectionDescription dangerouslySetInnerHTML={{ __html: t('academy.methods.description1') }}></SectionDescription>
                    </Section>

                    {(METHODS).map(
                        (area, key) => (
                            <TransportationOption key={key}>
                                <TransportationHeader id={`${area.id}`} onClick={() => toggleTransportationOption(area.id)}>
                                    <TransportationHeaderTexts
                                        className={openedAreas.includes(area.id) ? 'isOpen' : 'isClose'}
                                    >
                                        <TransportationHeaderTitle
                                            className={openedAreas.includes(area.id) ? 'isOpen' : 'isClose'}
                                        >
                                            {t(area.question)}
                                        </TransportationHeaderTitle>
                                        <TransportationHeaderDesc
                                            className={openedAreas.includes(area.id) ? 'isOpen' : 'isClose'}
                                            dangerouslySetInnerHTML={{ __html: t(area.description) }}
                                        >

                                        </TransportationHeaderDesc>
                                    </TransportationHeaderTexts>
                                    <TransportationHeaderRights>
                                        {/*<TransportationHeaderBanner>
                                            {area.banner}
                                        </TransportationHeaderBanner> */}
                                        <TransportationHeaderIcon
                                            className={openedAreas.includes(area.id) ? 'isOpen' : 'isClose'}
                                            name={Icons.ArrowDown}
                                        />
                                    </TransportationHeaderRights>
                                </TransportationHeader>
                                {openedAreas.includes(area.id) && area.id == 1 && (

                                    <TransportationDescription>

                                        <strong>Postup:</strong><br />
                                        <ol>

                                            <li>
                                                <strong>Výber a nákup:</strong> Vyberte si vzdelávací program a&nbsp;uhraďte ho priamo na&nbsp;našej webovej stránke profivzdelavanie.sk.
                                            </li>

                                            <li>
                                                <strong>Aktivácia:</strong> Ihneď po pripísaní platby vám zašleme e-mail s&nbsp;pokynmi, ako sa môžete začať vzdelávať.
                                            </li>
                                            <li>
                                                <strong>Vzdelávanie:</strong> Teraz sa môžete naplno venovať vzdelávaniu.
                                            </li>
                                            <li>
                                                <strong>Testovanie vedomostí:</strong> Ak vzdelávací program obsahuje viacero termínov školení, po&nbsp;každom z&nbsp;nich si overíte vedomosti krátkym testom. Po&nbsp;ukončení programu vás čaká záverečný test, v&nbsp;ktorom je potrebné dosiahnuť aspoň 75 %.
                                            </li>
                                            <li>
                                                <strong>Získanie osvedčenia:</strong> Po&nbsp;úspešnom absolvovaní záverečného testu vám vystavíme oficiálne osvedčenie, ktoré zvýši vašu hodnotu na&nbsp;trhu práce.
                                            </li>



                                        </ol>

                                        <strong>Upozornenie:</strong> Pri nákupe vzdelávacieho programu cez profivzdelavanie.sk nie je možné uplatniť štátnu dotáciu.

                                    </TransportationDescription>


                                )}
                                {openedAreas.includes(area.id) && area.id == 2 && (

                                    <TransportationDescription>

                                        <p>
                                            <strong>Výška dotácie: Až 200 € príspevok</strong> na vzdelávací program.<br /><br />
                                        </p>

                                        <p>
                                            <strong>O príspevok môže požiadať záujemca, ktorý:</strong>
                                            <ul>
                                                <li>má najmenej 16 rokov a v čase podania žiadosti nedovŕšil 65 rokov,</li>
                                                <li>je občanom SR alebo cudzincom s trvalým pobytom, prechodným pobytom, tolerovaným pobytom alebo s iným pobytom v SR,</li>
                                                <li>nie je žiakom strednej školy alebo študentom vysokej školy v dennej forme štúdia,</li>
                                                <li>nie je samostatne zárobkovo činnou osobou (SZČO). </li>
                                            </ul>


                                        </p>

                                        <p>
                                            <strong>Upozornenie:</strong> Program je nutné objednať výhradne cez portál vzdelavamsa.sk. Pri priamom zakúpení cez profivzdelavanie.sk nie je možné uplatniť dotáciu dodatočne.<br /><br />
                                        </p>

                                        <p>
                                            <strong>Postup, ako uplatniť dotáciu:</strong>
                                            <br /><br />
                                        </p>

                                        <p>
                                            <strong>1. Vyberte si vzdelávací program</strong>
                                        </p>

                                        <p>
                                            Na webovej stránke profivzdelavanie.sk si vyberte program, o ktorý máte záujem. Pozorne si poznačte jeho názov. Následne prejdite na platformu <Link href="https://vzdelavamsa.sk" target="_blank"><strong>vzdelavamsa.sk</strong></Link>, kde prebieha administrácia dotácií aj samotná objednávka.<br /><br />
                                        </p>


                                        <p>
                                            <strong>2. Registrácia na platforme vzdelavamsa.sk</strong>
                                        </p>

                                        <p>
                                            Vytvorte si používateľský účet na platforme vzdelavamsa.sk. K registrácii potrebujete platnú e-mailovú adresu a proces vám zaberie približne 5 minút. Po úspešnej registrácii a overení identity získate prístup k správe vašich vzdelávacích aktivít.
                                            <br /><br />
                                        </p>

                                        <p>
                                            <strong>3. Požiadajte o príspevok</strong>
                                        </p>

                                        <p>
                                            Po prihlásení do platformy vzdelavamsa.sk ihneď uvidíte výšku finančného príspevku, na ktorý máte nárok. Vyhľadajte vami zvolený vzdelávací program, ktorý chcete absolvovať a prihláste sa naň. Systém automaticky vygeneruje potrebné dokumenty a žiadosti na odsúhlasenie.
                                            <br />
                                            <br />
                                        </p>


                                        <p>
                                            <strong>4. Čestné vyhlásenie a doručenie</strong>
                                        </p>

                                        <p>
                                            Vytlačte čestné vyhlásenie, ktoré nájdete vo svojom konte na vzdelavamsa.sk, overte ho u notára a pošlite ho poštou našej vzdelávacej inštitúcii na adresu: Poradca podnikateľa, spol. s r.o., Mgr. Dominika Chládeková, PhD., Martina Rázusa 23A, 01001, Žilina.
                                            <br />
                                            <br />
                                        </p>

                                        <p>
                                            <strong>5. Absolvujte program cez profivzdelavanie.sk</strong>
                                        </p>

                                        <p>
                                            Vzdelávanie prebieha online cez profivzdelavanie.sk alebo prezenčne na vopred dohodnutom mieste. Pred začatím programu vám pošleme e-mail s podrobnými organizačnými pokynmi a inštrukciami k účasti.
                                            <br />
                                            <br />
                                        </p>

                                        <p>
                                            <strong>6. Testovanie a úspešné ukončenie</strong>
                                        </p>

                                        <p>
                                            Ak vzdelávací program obsahuje viacero termínov školení, po každom z nich si overíte vedomosti krátkym testom. Po ukončení programu vás čaká ešte jeden záverečný test, v ktorom musíte dosiahnuť aspoň 75 %.
                                            <br />
                                            <br />
                                        </p>

                                        <p>
                                            <strong>7. Spätná väzba</strong>
                                        </p>

                                        <p>
                                            Po ukončení programu vám systém <strong>vzdelavamsa.sk</strong> zašle žiadosť o hodnotenie spokojnosti. Vyplnenie spätnej väzby je povinné – bez jej odoslania vám nebude možné vystaviť osvedčenie.
                                            <br />
                                            <br />
                                        </p>
                                        <p>
                                            <strong>8. Získanie osvedčenia</strong>
                                        </p>

                                        <p>
                                            Po splnení všetkých podmienok nájdete svoje oficiálne osvedčenie priamo vo svojom konte na vzdelavamsa.sk.
                                            <br />
                                            <br />
                                        </p>
                                        <p>
                                            <strong>9. Doplatok (ak cena prevyšuje dotáciu)</strong>
                                        </p>

                                        <p>
                                            V prípade, že cena programu prevyšuje výšku schválenej dotácie, rozdiel uhradíte našej inštitúcii na základe faktúry, ktorú vám vystavíme. Splatnosť faktúry je 60 dní.
                                            <br />
                                            <br />
                                        </p>

                                    </TransportationDescription>

                                )}
                                {openedAreas.includes(area.id) && area.id == 3 && (

                                    <TransportationDescription>

                                        <p>
                                            <strong>Výška dotácie:</strong> Preplatenie vzdelávacieho programu <strong>v plnej výške</strong> po jeho úspešnom absolvovaní.
                                        </p>



                                        <strong>O príspevok môže požiadať záujemca o zamestnanie (ZoZ), ktorý:</strong><br />

                                        <ul>
                                            <li>je evidovaný na úrade práce ako záujemca o zamestnanie,</li>
                                            <li>nepodniká ani nevykonáva samostatnú zárobkovú činnosť, </li>
                                            <li>si hľadá nové pracovné uplatnenie alebo má záujem o vzdelávanie a poradenské služby pre trh práce,</li>
                                            <li>nie je študentom denného štúdia, </li>
                                            <li>nepoberá starobný dôchodok ani invalidný dôchodok po dovŕšení dôchodkového veku, </li>
                                            <li>vyberie si vzdelávanie, ktoré súvisí s jeho budúcim uplatnením na trhu práce,</li>
                                            <li>smeruje na profesiu, po ktorej je dopyt na trhu práce, </li>
                                            <li>získa zručnosti využiteľné na trhu práce (napr. digitálne, zelené alebo nedostatkové profesie). </li>
                                        </ul>

                                        <p>
                                            <strong>Príspevok nie je možné získať na:</strong> Obnovu alebo aktualizáciu existujúcich zručností, prípadne na&nbsp;rovnaké alebo podobné vzdelávanie, na&nbsp;ktoré už bol príspevok poskytnutý za&nbsp;posledných 5 rokov.
                                        </p>

                                        <p>
                                            <strong>Upozornenie:</strong> Žiadosť o príspevok musíte podať najneskôr 30 kalendárnych dní pred&nbsp;začiatkom vzdelávacieho programu. Dotáciu nie je možné uplatniť spätne na už prebiehajúci alebo ukončený vzdelávací program.
                                            <br /> <br />
                                        </p>

                                        <p>
                                            <strong>Postup, ako získať a uplatniť príspevok:</strong>
                                        </p>

                                        <p>
                                            <strong>1. Staňte sa „záujemcom o zamestnanie“</strong>
                                        </p>

                                        <p>
                                            Ak ešte nie ste v evidencii, navštívte ktorýkoľvek úrad práce a podajte si <Link href="https://www.upsvr.gov.sk/buxus/docs/SSZ/OISS/TLACIVA/2026/Ziadost_o_zaradenie_UoZ_od_01.01.2026.docx" target="_blank"><strong>„Žiadosť ZoZ o sprostredkovanie vhodného zamestnania“</strong></Link>. Bez tejto registrácie nie je možné o príspevok žiadať.<br /><br />
                                        </p>

                                        <p>
                                            <strong>2. Vyberte si vzdelávací program</strong>
                                        </p>

                                        <p>
                                            Na našej webovej stránke profivzdelavanie.sk si vyberte program, ktorý vám pomôže pri zlepšení postavenia na trhu práce alebo pri zmene profesie.<br /><br />
                                        </p>

                                        <p>
                                            <strong>3. Vyplňte žiadosť o príspevok</strong>
                                        </p>

                                        <p>
                                            Stiahnite si formulár <Link href="https://www.upsvr.gov.sk/buxus/docs/SSZ/OAOTP/ZpTP_ZoZ/Priloha_1__Ziadost_ZoZ.docx" target="_blank"><strong>„Žiadosť o poskytnutie príspevku na podporu vzdelávania ZoZ“</strong></Link> alebo si ho vyžiadajte priamo na úrade.<br /><br />
                                        </p>

                                        <p>
                                            <strong>4. Príprava povinnej prílohy (Potvrdenie od nás)</strong>
                                        </p>

                                        <p>
                                            K žiadosti o poskytnutie príspevku potrebujete doložiť <Link href="https://www.upsvr.gov.sk/buxus/docs/SSZ/OAOTP/ZpTP_ZoZ/Priloha_2_ZoZ_Potvrdenie_poskytovatela.docx" target="_blank"><strong>„Potvrdenie poskytovateľa vzdelávania o zabezpečení vzdelávania“</strong></Link>. Predvyplňte v ňom svoje osobné údaje a údaje o programe (vrátane formy a rozsahu) a pošlite nám ho na e-mail: <Link href="mailto:profivzdelavanie@pp.sk" target="_blank"><strong>profivzdelavanie@pp.sk</strong></Link>. My doplníme zvyšné údaje v žiadosti.<br /><br />
                                        </p>

                                        <p>
                                            <strong>5. Potvrdíme vám dokument a priložíme cenový prieskum</strong>
                                        </p>

                                        <p>
                                            Finálny dokument „Potvrdenie poskytovateľa vzdelávania o zabezpečení vzdelávania“ vám pošleme na e-mail a priložíme k nemu povinný cenový prieskum (nie starší ako 3 mesiace), ktorý vypracujeme za vás.<br /><br />
                                        </p>

                                        <p>
                                            <strong>6. Podajte žiadosť na úrad (najneskôr 30 dní pred kurzom)</strong>
                                        </p>

                                        <p>
                                            Kompletnú „Žiadosť o poskytnutie príspevku na podporu vzdelávania ZoZ“ spolu s naším potvrdením a cenovým prieskumom doručte úradu práce v mieste vášho trvalého pobytu (osobne, poštou alebo cez slovensko.sk).
                                        </p>

                                        <p>
                                            Ak doručujete žiadosť cez portál slovensko.sk musí byť žiadosť podpísaná výlučne kvalifikovaným elektronickým podpisom.
                                        </p>

                                        <p>
                                            Žiadosť musí byť na úrade zaevidovaná najneskôr 30 kalendárnych dní pred začiatkom vzdelávania. Rozhodujúci je dátum doručenia (zaevidovania v podateľni úradu, resp. elektronického doručenia), nie dátum odoslania na pošte.<br /><br />
                                        </p>

                                        <p>
                                            <strong>7. Počkajte na schválenie</strong>
                                        </p>

                                        <p>
                                            Na príspevok nie je automatický nárok. Úrad posúdi, či má kurz zmysel pre vašu kariéru a či je cena vyhovujúca.<br /><br />
                                        </p>

                                        <p>
                                            <strong>8. Podpis dohody</strong>
                                        </p>

                                        <p>
                                            Po schválení s vami úrad podpíše dohodu (osobne, elektronicky cez slovensko.sk alebo poštou). Súčasťou dohody sú dôležité prílohy, ktoré budete ešte potrebovať:
                                        </p>

                                        <p>
                                            <ol>
                                                <li>Vzdelávací poukaz</li>
                                                <li> Žiadosť o úhradu príspevku na podporu vzdelávania záujemcu o zamestnanie</li>
                                                <li>Splnomocnenie na úhradu ceny vzdelávania (kurzovného)</li>
                                            </ol>
                                        </p>

                                        <p>
                                            <strong>9. Vyplňte Žiadosť o úhradu príspevku</strong>
                                        </p>

                                        <p>
                                            Vyplňte „Žiadosť o úhradu príspevku na podporu vzdelávania záujemcu o zamestnanie“ (príloha k dohode) a starostlivo si ju uchovajte.<br /><br />
                                        </p>

                                        <p>
                                            <strong>10. Odovzdajte nám Vzdelávací poukaz</strong>
                                        </p>

                                        <p>
                                            Najneskôr v deň začatia vzdelávania ste povinný odovzdať nám Vzdelávací poukaz (príloha k dohode).<br /><br />
                                        </p>

                                        <p>
                                            <strong>11. Absolvujte program a získajte osvedčenie</strong>
                                        </p>

                                        <p>
                                            Ak vzdelávací program obsahuje viacero termínov školení, po každom z nich si overíte vedomosti krátkym testom. Po ukončení programu vás čaká ešte jeden záverečný test, v ktorom musíte dosiahnuť aspoň 75 %. Následne vám vystavíme oficiálne osvedčenie o absolvovaní, ktoré slúži ako doklad pre úrad.<br /><br />
                                        </p>

                                        <p>
                                            <strong>12. Skompletizujte dokumentáciu pre preplatenie</strong>
                                        </p>

                                        <p>
                                            Pre úhradu kurzovného si pripravte tieto dokumenty:
                                        </p>

                                        <ul>
                                            <li>Žiadosť o úhradu príspevku (získali ste ako prílohu k dohode)</li>
                                            <li>Faktúra za vzdelávanie (vystavíme vám ju do 10 kalendárnych dní od ukončenia vzdelávacieho programu)</li>
                                            <li>Osvedčenie o absolvovaní vzdelávania (kópia)</li>
                                            <li>Splnomocnenie na úhradu ceny kurzovného – originál (získali ste ako prílohu k dohode)</li>
                                        </ul>


                                        <p>
                                            <strong>13. Predložte úradu žiadosť o úhradu príspevku</strong>
                                        </p>

                                        <p>
                                            Všetky dokumenty z bodu 12 doručte úradu najneskôr do 30 kalendárnych dní od ukončenia vzdelávania, pričom rozhodujúci je dátum doručenia úradu (t. j. zaevidovania v podateľni úradu, resp. elektronického doručenia). Po splnení podmienok úrad uhradí kurzovné priamo našej inštitúcii do 30 dní.
                                        </p>


                                    </TransportationDescription>


                                )}

                            </TransportationOption>
                        )
                    )}
                </Sections>
            </Wrapper >
        </ContentWrapper >
    );
};
export default AcademyMethodsTemplate;
